import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { Box } from '@mui/material';

import AddButton from '../../../../../components/Button/ActionButtons/AddButton';
import SectionCard from '../../components/SectionCard';
import { dplOptionShape } from '../../components/DplPicker';
import { DPL_OPTIONS_STATUS } from '../../hooks/useDplOptions';
import texts from '../../texts.json';
import BlastBlock from './BlastBlock';

const copy = texts.reengagement.scheduledTexts;

const ScheduledTextsSection = ({
  blasts,
  blastsMeta,
  dplOptions,
  dplStatus,
  onBodyChange,
  onOffsetChange,
  onDplChange,
  onImageChange,
  onImageError,
  onRemoveBlast,
  onAddBlast,
  coachName,
}) => {
  const summary = format(copy.queuedSummary, { count: blasts.length });

  return (
    <SectionCard title={copy.title} subtitle={summary}>
      {blasts.map((blast, idx) => (
        <BlastBlock
          key={blast.key}
          index={idx + 1}
          blast={blast}
          meta={blastsMeta[idx]}
          dplOptions={dplOptions}
          dplStatus={dplStatus}
          onBodyChange={(body) => onBodyChange(blast.key, body)}
          onOffsetChange={(offset) => onOffsetChange(blast.key, offset)}
          onDplChange={(dpl) => onDplChange(blast.key, dpl)}
          onImageChange={(image) => onImageChange(blast.key, image)}
          onImageError={(hasError) => onImageError(blast.key, hasError)}
          onRemove={() => onRemoveBlast(blast.key)}
          canRemove={blasts.length > 1}
          coachName={coachName}
        />
      ))}
      <Box sx={{ mt: 2 }}>
        <AddButton variant="muted" onClick={onAddBlast}>
          {copy.addAnother}
        </AddButton>
      </Box>
    </SectionCard>
  );
};

ScheduledTextsSection.propTypes = {
  blasts: PropTypes.arrayOf(PropTypes.object).isRequired,
  blastsMeta: PropTypes.arrayOf(PropTypes.object).isRequired,
  dplOptions: PropTypes.arrayOf(dplOptionShape).isRequired,
  dplStatus: PropTypes.oneOf(Object.values(DPL_OPTIONS_STATUS)).isRequired,
  onBodyChange: PropTypes.func.isRequired,
  onOffsetChange: PropTypes.func.isRequired,
  onDplChange: PropTypes.func.isRequired,
  onImageChange: PropTypes.func.isRequired,
  onImageError: PropTypes.func.isRequired,
  onRemoveBlast: PropTypes.func.isRequired,
  onAddBlast: PropTypes.func.isRequired,
  coachName: PropTypes.string,
};

ScheduledTextsSection.defaultProps = {
  coachName: '',
};

export default ScheduledTextsSection;
